import { WebhookEntityType } from '../../entities/webhooks-v2/webhook.entity.type';

export const AgentHarnessSourceEntityType = {
    Job: WebhookEntityType.Job,
    Stage: WebhookEntityType.Stage,
    Activity: WebhookEntityType.Activity,
    Task: WebhookEntityType.Task,
    Work: 'work',
    StageItem: 'stage_item',
} as const;

export type AgentHarnessSourceEntityType = typeof AgentHarnessSourceEntityType[keyof typeof AgentHarnessSourceEntityType];
